import { IdeaFieldTypes } from 'common/constants/ideas';

export enum CustomPostFieldTypes {
  integer = IdeaFieldTypes.number,
  multilineText = IdeaFieldTypes.multilineText,
  multiselect = IdeaFieldTypes.multiselect,
  dropdown = IdeaFieldTypes.dropdown,
  text = IdeaFieldTypes.text,
}

export interface CustomPostField {
  _id: string;
  name: string;
  options?: string[];
  type: CustomPostFieldTypes;
  value: any;
}

export type BoardField = CustomPostField & {
  customPostFieldID: string;
  label: string;
  order: number;
  required: boolean;
  placeholder: string;
};
